__webpack_require__.p = "/brandguide/";